<template>
  <highcharts
    v-if="config"
    ref="chart"
    class="chart"
    v-bind="config"
  />
</template>

<script>
import Highcharts from 'highcharts';
import stockInit from 'highcharts/modules/stock';
import brokenAxis from 'highcharts/modules/broken-axis';

stockInit(Highcharts);
brokenAxis(Highcharts);

import { getConfig } from './config';

const DEFAULT_AXIS_CONFIG = {
  margin: 100,
  title: { enabled: false },
  labels: {
    enabled: false,
    formatter: function () {
      return this.value;
    },
  },
};

// Нужно сделать возможность настройки конфига из вне.
export default {
  data() {
    return {
      config: getConfig({ afterSetExtremes: this.afterSetExtremes }),

      initialRange: {
        series: null,
        min: null,
        max: null,
      },
    };
  },

  mounted() {
    this.adjustChartHeight();
  },

  methods: {
    getChartInstance() {
      return this.$refs.chart.chart;
    },

    afterSetExtremes(e) {
      this.$emit('afterSetExtremes', e);
    },

    fillChartRange(seriesItem) {
      if (seriesItem.data[0]) {
        if (!this.initialRange.min) {
          this.initialRange.min = seriesItem.data[0].x;
        } else {
          if (seriesItem.data[0].x < this.initialRange.min) {
            this.initialRange.min = seriesItem.data[0].x;
          }
        }

        const { length } = seriesItem.data;
        if (!this.initialRange.max) {
          this.initialRange.max = seriesItem.data[length - 1].x;
        } else {
          if (seriesItem.data[0].x > this.initialRange.max) {
            this.initialRange.max = seriesItem.data[length - 1].x;
          }
        }

        const data = [
          { x: this.initialRange.min, y: 0 },
          { x: this.initialRange.max, y: 0 },
        ];

        const id = 'RANGE_SERIES';
        const { chart } = this.$refs.chart;
        if (!this.initialRange.series) {
          /// TODO: USE ADD SERIES SOMEHOW
          const yAxis = id + 'axis';
          chart.addAxis(
            { ...DEFAULT_AXIS_CONFIG, id: yAxis },
            false,
            false,
            false
          );

          this.initialRange.series = {
            color: 'white',
            data,
            id,
            showInNavigator: false,
            visible: true,
          };
          chart.addSeries({ ...this.initialRange.series, yAxis });
        } else {
          const s = chart.get(id);
          s.setData(s, false, false, false);
        }
      }
    },

    addSeriesWithDefaultAxis(series) {
      const { chart } = this.$refs.chart;

      for (const seriesItem of series) {
        this.fillChartRange(seriesItem);
        const yAxis = `${seriesItem.id}-axis`;
        const ifAxisIsExists = chart.get(yAxis);
        if (!ifAxisIsExists) {
          // console.log(`Axis ${yAxis} does not exist. Creating...`);
          chart.addAxis(
            { ...DEFAULT_AXIS_CONFIG, id: yAxis },
            false,
            false,
            false
          );
        }
        chart.addSeries({ ...seriesItem, yAxis }, false, false);
      }

      chart.redraw(false);
    },

    getChartObject(id) {
      const { chart } = this.$refs.chart;
      const obj = chart.get(id);
      if (!obj) {
        throw new Error('Highcahrt object was not found');
      }
      return obj;
    },

    setSeriesVisibility(seriesId, value) {
      this.getChartObject(seriesId).setVisible(value);
    },

    setYAxisLabelsVisibility(id, value) {
      const yAxisId = `${id}-axis`;
      const yAxis = this.getChartObject(yAxisId);
      yAxis.update({
        labels: {
          enabled: value,
        },
      });
    },

    turnOffYAxisLabels() {
      for (const yAxis of this.$refs.chart.chart.yAxis) {
        if (yAxis.options.id === 'navigator-y-axis') {
          continue;
        }

        if (yAxis.options.labels.enabled) {
          yAxis.update({
            labels: {
              enabled: false,
            },
          });
        }
      }
    },

    adjustChartHeight() {
      // this.$nextTick(() => {
      //   const children = this.$refs.chart.$el.parentNode.children;
      //   let overallHeight = 0;
      //   for (const child of children) {
      //     if (child != this.$refs.chart.$el) {
      //       const style = child.currentStyle || window.getComputedStyle(child);
      //       let marginBottom = Number(style.marginBottom.split("px")[0]);
      //       let marginTop = Number(style.marginTop.split("px")[0]);
      //       marginBottom = isNaN(marginBottom) ? 0 : marginBottom;
      //       marginTop = isNaN(marginTop) ? 0 : marginTop;
      //       const rect = child.getBoundingClientRect();
      //       overallHeight += rect.height + marginBottom + marginTop;
      //     }
      //   }
      //   const parentheight =
      //     this.$refs.chart.$el.parentNode.getBoundingClientRect().height;
      //   const highchartsInstance = this.getChartInstance();
      //   highchartsInstance.setSize(null, parentheight - overallHeight);
      // });
    },
  },
};
</script>


<style  lang="scss" scoped>
.chart {
  height: 100%;
  // display: flex;
  // flex: 1;
}
.highcharts-container {
  height: 100%;
  // display: flex;
}
</style>